document.addEventListener("DOMContentLoaded", function() {

    document.addEventListener("change", function(e) {
      
        if (e.target.closest(".bundleCheck_variant")) {

          const radio = e.target.closest(".bundleCheck_variant");
          const variantId = radio.dataset.id;
          const variantPrice = radio.dataset.price;
          const parent = radio.closest(".pro_list");
          if (!parent) return;
          const checkbox = parent.querySelector(".bundleCheck");
          if (!checkbox) return;
          checkbox.dataset.id = variantId;
          checkbox.dataset.proPrice = variantPrice;
        }

        if (e.target.matches(".bundleCheck")) {
            function getBundleTotal() {
                let total = 0;
                document.querySelectorAll(".bundleCheck:checked").forEach(cb => {
                    const price = parseInt(cb.dataset.proPrice) || 0;
                    total += price;
                });
                return total;
            }

            const checkedCount = document.querySelectorAll(".bundleCheck:checked").length;
            const total = getBundleTotal();
            const btn = document.querySelector(".bundle_addToCart");
            const save_text = document.querySelector(".saving_text");
            const checkbox = e.target;
            const variantBox = checkbox.closest(".pro_list").querySelector(".pro_variants");
            if (checkbox.checked) {
              if(variantBox)
              {
                variantBox.classList.remove("hidden");
              }
            } else {
              if(variantBox)
              {
                variantBox.classList.add("hidden");
                variantBox.querySelectorAll(".bundleCheck_variant").forEach(radio => {
                  radio.checked = false;
                });
              }
            }
            if(checkedCount > 0)
            {
                document.querySelector(".bundle_addToCart").classList.remove("hidden");
                document.querySelector(".saving_text").classList.remove("hidden");
                const currencySymbol = btn.dataset.currencySymbol || '$';
const saving = total * 0.50;
const finalPrice = total - saving;
btn.textContent = `Add ${checkedCount} items — ${currencySymbol}${(finalPrice / 100).toFixed(2)}`;
save_text.textContent = `You are saving ${currencySymbol}${(saving / 100).toFixed(2)}`;
            }else{
                document.querySelector(".bundle_addToCart").classList.add("hidden");
                document.querySelector(".saving_text").classList.add("hidden");
            }
        }
    });

    document.querySelector(".bundle_addToCart")?.addEventListener("click", function (e) {
      e.preventDefault();

      let arrPdp = [];

      document.querySelectorAll(".bundleCheck:checked").forEach(cb => {
        arrPdp.push({
          id: cb.dataset.id,
          quantity: 1
        });
      });


      const mainVariantId = document.querySelector('.form [name="id"]')?.value;

      if (mainVariantId) {
        arrPdp.push({
          id: mainVariantId,
          quantity: 1
        });
      }

      if (!arrPdp.length) {
        alert("Please select at least one item");
        return;
      }

      console.log("Final arrPdp:", arrPdp);

      document.querySelector(".bundle_addToCart").classList.add("loading");
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: arrPdp })
      })
      .then(() => fetch('/?sections=cart-drawer,cart-icon-bubble'))
      .then(res => res.json())
      .then(sections => {

        const parser = new DOMParser();

        const drawerHTML = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawer = drawerHTML.querySelector('cart-drawer');

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
        }

        const bubbleHTML = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = bubbleHTML.querySelector('#cart-icon-bubble');

        const bubble = document.querySelector('#cart-icon-bubble');
        if (bubble && newBubble) {
          bubble.innerHTML = newBubble.innerHTML;
        }

        document.querySelector('cart-drawer')?.classList.add('active');
        document.querySelector('cart-drawer')?.classList.remove('is-empty');
        document.body.classList.add('overflow-hidden');
         document.querySelector(".bundle_addToCart").classList.remove("loading");

      })
      .catch(err => console.error(err));

});

    
    
    // upsell js in cart drawer
    document.addEventListener("click", function (e) {

        const el = e.target.closest(".upcell-product");
        if (!el) return;

        if (el.classList.contains("loading")) return;
         el.classList.add("loading");

        const pro_id = el.dataset.upcellProduct;
        // console.log("pro_id", pro_id);

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
            id: pro_id,
            quantity: 1
            })
        })
        .then(res => res.json())
        .then(res => {

            if (res.status === 422) {
            console.log("Out of stock");
            return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external' });
            el.classList.add("added");
            return fetch('/cart.js');

        })
        .then(res => res.json())
        .then(cart => {

            if (cart.item_count > 0) {

            document.querySelector(".drawer__inner-empty")?.remove();
            document.querySelector("cart-drawer")?.classList.remove("is-empty");
            document.querySelector(".cart-count-bubble")?.remove();

            const html = `
                <div class="cart-count-bubble">
                <span aria-hidden="true">${cart.item_count}</span>
                <span class="visually-hidden">${cart.item_count} items</span>
                </div>`;

            document.querySelector(".header__icon--cart span")
                ?.insertAdjacentHTML("afterend", html);
            }

        })
        .catch(err => console.error(err))
        .finally(() => {
            el.classList.remove("loading");
        });  

        });
    // end upsell js in cart drawer
});


// Start Search Focus

document.addEventListener("click", function (e) {
  if (e.target.closest(".header__icon--menu")) {
    setTimeout(() => {
      const input = document.getElementById('Search-In-Modal');
      input?.focus();
    }, 200);
  }
});

// End Search Focus

// Start Home Hero Slider

let lolaSwiperInstance = null;

function lolaHome() {
  const isMobile = window.innerWidth <= 767;
  if (isMobile && !lolaSwiperInstance) {
    lolaSwiperInstance = new Swiper(".lolaSwiper", {
      slidesPerView: 1.086,
      spaceBetween: 4,

      pagination: {
        el: ".lolaSwiper .swiper-pagination",
        clickable: true,
      },

      navigation: {
        nextEl: ".lolaSwiper .swiper-button-next",
        prevEl: ".lolaSwiper .swiper-button-prev",
      },
    });
  } 
  if (!isMobile && lolaSwiperInstance) {
    lolaSwiperInstance.destroy(true, true);
    lolaSwiperInstance = null;
  }
}
lolaHome();
window.addEventListener("resize", lolaHome);

// End Home Hero Slider

// End PDP Bundle Product Variant

document.addEventListener("DOMContentLoaded", function () {
  function handleVariantsPosition() {
    const isMobile = window.innerWidth <= 767;
    const products = document.querySelectorAll(".pro_list");
    products.forEach((product) => {
      const productId = product.querySelector(".bundleCheck")?.dataset.id;
      if (!productId) return;
      const allVariants = document.querySelectorAll(".pro_variants");
      allVariants.forEach((variantBlock) => {
        const firstVariant = variantBlock.querySelector(".bundleCheck_variant");
        if (!firstVariant) return;
        const variantProductId = firstVariant.dataset.id;
        if (variantProductId === productId) {
          if (isMobile) {
            product.appendChild(variantBlock);
          } else {
            product.insertAdjacentElement("afterend", variantBlock);
          }
        }
      });
    });
  }
  handleVariantsPosition();
  window.addEventListener("resize", handleVariantsPosition);
});

// End PDP Bundle Product Variant

// Menu Drawer Close Button

document.addEventListener("DOMContentLoaded", function () {
  const closeBtn = document.querySelector(".menu-drawer__close");
  const menuBtn = document.querySelector(".header__icon--menu");

  if (closeBtn && menuBtn) {
    closeBtn.addEventListener("click", function () {
      menuBtn.click();
    });
  }
});

// End Menu Drawer Close Button

document.addEventListener("DOMContentLoaded", function () {
  const allDetails = document.querySelectorAll('.accordion details');

  allDetails.forEach((currentDetail) => {
    const summary = currentDetail.querySelector('summary');

    summary.addEventListener('click', function () {
      setTimeout(() => {
        if (currentDetail.hasAttribute('open')) {
          
          allDetails.forEach((detail) => {
            if (detail !== currentDetail) {
              detail.removeAttribute('open');

              const otherSummary = detail.querySelector('summary');
              if (otherSummary) {
                otherSummary.setAttribute('aria-expanded', 'false');
              }
            }
          });

        }
      }, 0);
    });
  });
});

document.querySelectorAll('.accordion details').forEach((detail) => {
  const summary = detail.querySelector('summary');
  const content = detail.querySelector('.accordion__content');

  summary.addEventListener('click', function (e) {
    e.preventDefault();

    const isOpen = detail.hasAttribute('open');

    document.querySelectorAll('.accordion details').forEach((d) => {
      const c = d.querySelector('.accordion__content');
      if (d !== detail) {
        d.removeAttribute('open');
        c.style.maxHeight = null;
      }
    });

    if (isOpen) {
      content.style.maxHeight = content.scrollHeight + 'px';
      requestAnimationFrame(() => {
        content.style.maxHeight = '0px';
      });

      // setTimeout(() => {
        detail.removeAttribute('open');
      // }, 100);
    } else {
      detail.setAttribute('open', true);
      content.style.maxHeight = '0px';
      requestAnimationFrame(() => {
        content.style.maxHeight = content.scrollHeight + 'px';
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const bar = document.querySelector(".sticky-atc-bar");
  const atcSection = document.querySelector(".product-add-to-cart");

  const stickyBtn = document.querySelector("#StickyAddToCart");
  const mainBtn = document.querySelector(".product-form__submit");
  const spinner = stickyBtn?.querySelector(".loading__spinner");

  // ===== VISIBILITY =====
  function checkPosition() {
    if (!atcSection) return;

    const rect = atcSection.getBoundingClientRect();

    if (rect.bottom < 0) {
      bar.classList.add("show");
      bar.classList.remove("hide");
    } else {
      bar.classList.remove("show");
      bar.classList.add("hide");
    }
  }

  checkPosition();
  window.addEventListener("scroll", checkPosition);

  // ===== LOADER CONTROL =====
  function startLoading() {
    stickyBtn.classList.add("loading");
    stickyBtn.setAttribute("disabled", true);
    if (spinner) spinner.classList.remove("hidden");
  }

  function stopLoading() {
    if (!stickyBtn) return;
    stickyBtn.classList.remove("loading");
    stickyBtn.removeAttribute("disabled");
    if (spinner) spinner.classList.add("hidden");
}

  // ===== INTERCEPT FETCH (REAL SIGNAL) =====
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = args[0];

      // detect add to cart request
      if (typeof url === "string" && url.includes("/cart/add")) {
        stopLoading(); // ✅ stop loader when request completes
      }
    } catch (e) {
      stopLoading(); // fallback
    }

    return response;
  };

  // ===== CLICK =====
  if (stickyBtn && mainBtn) {
    stickyBtn.addEventListener("click", () => {
      if (stickyBtn.classList.contains("loading")) return;

      startLoading();
      mainBtn.click();
    });
  }
});

document.addEventListener("DOMContentLoaded",() => {
  let hasOffItem = false;

        document.querySelectorAll(".cart-items .cart-item").forEach(ele => {
          if (ele.classList.contains("off_item")) {
            hasOffItem = true;
          }
        });

        if (hasOffItem) {
          document.querySelector(".off_info")?.classList.remove("hidden");
          document.querySelector(".default_text")?.classList.add("hidden");
          document.querySelectorAll(".off_badge").forEach(el => {
            el.classList.remove("hidden");
          });
        } else {
          document.querySelector(".off_info")?.classList.add("hidden");
          document.querySelector(".default_text")?.classList.remove("hidden");
          document.querySelectorAll(".off_badge").forEach(el => {
            el.classList.add("hidden");
          });
        }
});
// Instant press feedback on quick-add buttons (touch + click)
document.addEventListener("touchstart", function (e) {
  const quickAddBtn = e.target.closest(".quick-add__submit");
  if (!quickAddBtn) return;
  quickAddBtn.classList.add("is-pressed");
}, { passive: true });

document.addEventListener("touchend", function (e) {
  const quickAddBtn = e.target.closest(".quick-add__submit");
  if (!quickAddBtn) return;
  setTimeout(() => quickAddBtn.classList.remove("is-pressed"), 150);
}, { passive: true });

// Instant loading state on quick-add buttons
document.addEventListener("click", function (e) {
  const quickAddBtn = e.target.closest(".quick-add__submit");
  if (!quickAddBtn) return;
  if (quickAddBtn.classList.contains("loading")) return;
  
  quickAddBtn.classList.add("loading");
  
  // Safety timeout — clear loading after 5s in case something hangs
  setTimeout(() => quickAddBtn.classList.remove("loading"), 5000);
});